import { Box, Typography } from '@mui/material';
import { styled } from '@mui/styles';
import { useGetPartnerUserInfo } from 'partner/shared/hooks/use-get-partner-user-info';
import { PolicyGroups } from 'shared/utils/policy-controller';
import { PartnerAuthenticatedElement } from 'partner/shared/components/partner-authenticated-element/partner-authenticated-element';
import { usePartnerSidebarProvider } from './sidebar-provider';

export const SidebarPartnerName = () => {
  const { isOpen } = usePartnerSidebarProvider();
  const { data: user } = useGetPartnerUserInfo();

  return isOpen ? (
    <PartnerAuthenticatedElement roles={'PARTNER'} policyGroup={PolicyGroups.PARTNER}>
      <StyledCompanyInfoBox>
        <StyledCompanyName variant="body1">{user?.partner.name}</StyledCompanyName>
      </StyledCompanyInfoBox>
    </PartnerAuthenticatedElement>
  ) : null;
};

const StyledCompanyInfoBox = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  textOverflow: 'ellipsis',
  textAlign: 'center',
}));

const StyledCompanyName = styled(Typography)(() => ({
  overflow: 'hidden',
}));
